import { render, staticRenderFns } from "./RegistrationButtons.vue?vue&type=template&id=806fe010&"
import script from "./RegistrationButtons.vue?vue&type=script&lang=js&"
export * from "./RegistrationButtons.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports